import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { isDataDrivenGenerationTool } from 'src/data/generationTool';
import { ONBOARDING_STAGE } from 'src/data/onboarding';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { ROUTES } from 'src/routes';
import { OnboardingStore, useCurrentUser, useOnboardingActions, useUserActions } from 'src/store';

import { ListViewStore, MainStore } from '../store';

const useMainStore = createStateSelectorHook(MainStore, ['currentVisiblePopup']);

const useListViewStore = createStateSelectorHook(ListViewStore, [
  'lastGenerationTimestamp',
  'generationResults',
]);

const useOnboardingState = createStateSelectorHook(OnboardingStore, ['currentStage']);

export const useVariationOnboardingHints = () => {
  const location = useLocation();
  const { currentVisiblePopup } = useMainStore();
  const { lastGenerationTimestamp, generationResults } = useListViewStore();
  const userActions = useUserActions();
  const { currentStage } = useOnboardingState();

  const [alreadyShown, setAlreadyShown] = useState(false);

  const onboardingActions = useOnboardingActions();
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    // We want "variations" tooltip only on this route
    if (!location.pathname.startsWith(ROUTES.PROJECTS)) {
      return;
    }

    // We don't want to start another flow, if one is already in progress
    if (onboardingActions.getIsActive()) {
      return;
    }

    // We DONT want to display the hint if one of "onboarding" popups is open
    if (currentVisiblePopup) {
      return;
    }

    // We want to display the hint only after a successful generation
    if (!lastGenerationTimestamp) {
      return;
    }
    const isLastGenerationDataDriven = isDataDrivenGenerationTool(
      generationResults[0]?.generationTool
    );

    if (!isLastGenerationDataDriven) {
      return;
    }

    const documentVariationsStageIsFinished = userActions.isFinishedOnboardingStage(
      ONBOARDING_STAGE.documentVariations
    );

    if (documentVariationsStageIsFinished || alreadyShown) {
      return;
    }

    onboardingActions.startOnboarding(ONBOARDING_STAGE.documentVariations);
    setAlreadyShown(true);
  }, [
    currentStage,
    currentUser,
    onboardingActions,
    generationResults,
    location,
    lastGenerationTimestamp,
    userActions,
    currentVisiblePopup,
    alreadyShown,
  ]);
};
